import accessControl from "../config/access-control.json";

const normalizeEmail = (email: string): string => email.trim().toLowerCase();

const adminEmails = new Set(
  (accessControl.panchangam_admin ?? []).map((email) => normalizeEmail(email)),
);

const userEmails = new Set(
  (accessControl.panchangam_user ?? []).map((email) => normalizeEmail(email)),
);

export const getPanchangamAccessForEmail = (email?: string): { isAdmin: boolean; isAllowed: boolean } => {
  if (!email) {
    return { isAdmin: false, isAllowed: false };
  }

  const normalizedEmail = normalizeEmail(email);
  const isAdmin = adminEmails.has(normalizedEmail);
  const isAllowed = isAdmin || userEmails.has(normalizedEmail);

  return { isAdmin, isAllowed };
};
